<template>
  <div class="handle-in-time">
    <div class="flex-align-center" style="margin-bottom: 15px">
      <img src="@/assets/imgs/school/monthRecord/star.png" alt="" class="star" />
      <div class="title title-2" style="color: #304efa">
        {{ title }}
      </div>
    </div>
    <div v-if="dataSource.length" class="list">
      <div v-for="(item, index) in dataSource" :key="index" class="list-item flex-between">
        <div class="flex-center">
          <img
            src="@/assets/imgs/school/monthRecord/checkMark.png"
            alt=""
            class="rank-icon"
            style="margin-right: 10px"
          />
          <div>{{ item.className }} –</div>
        </div>
        <div>班主任：{{ item.teacherName }}</div>
      </div>
    </div>
    <!--空状态-->
    <EmptyData v-else />
    <a-divider style="margin: 15px 0" />
    <div v-if="dataSource.length" class="bottom-text">
      <div>
        <span>说明：</span>
        <span>处理记录详实、规范，关怀措施针对性强、可作为典型案例推广</span>
      </div>
      <div>
        <span>优秀案例亮点：</span>
        <span>① 详细记录学生情绪波动原因 ② 制定个性化关怀方案 ③ 持续跟踪反馈效果</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RecordCarefully',
  props: {
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="less">
.handle-in-time {
  padding: 20px;
  background-color: #edf4ff;
  border-radius: 10px;
  .star {
    width: 20px;
    height: 20px;
    margin-right: 10x;
  }
  .list {
    .list-item {
      padding: 10px 15px;
      margin-bottom: 10px;
      border-radius: 5px;
      background-color: #fff;
      .rank-icon {
        width: 20px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
  .bottom-text {
    line-height: 1.5;
  }
}
</style>
